import protectedAxios from "axios";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Actions from "../payments/duck/actions";
import { API_URL } from "./constants";
import countryToCurrency from "country-to-currency";
import getSymbolFromCurrency from "currency-symbol-map";

function useExchangeRate() {
  const dispatch = useDispatch();

  const currentCountry = useSelector(
    (state) => state.payments.location.country
  );
  const currentCountryCode = useSelector(
    (state) => state.payments.location.countryCode
  );
  const currencyCode = countryToCurrency[currentCountryCode];
  const currencySymbol = getSymbolFromCurrency(currencyCode);

  useEffect(() => {
    if (currentCountry) {
      protectedAxios
        .get(
          `${API_URL}/v1/payment/collection/exchange-rates?currentCurrencyCode=${currencyCode}`
        )
        .then((res) => {
          if (res?.data?.exchangeRate) {
            dispatch(
              Actions.setExchangeRate(res.data.exchangeRate?.exchangeRate || 1)
            );
          } else {
            dispatch(Actions.setExchangeRate(1));
          }
        })
        .catch((error) => {
          console.error(error);
          dispatch(Actions.setExchangeRate(1));
        });
    } else {
      dispatch(Actions.setExchangeRate(1));
    }
  }, [currentCountry]);
}

export default useExchangeRate;
